<template>
	<div class="goods-detail">
		<div class="preview-wrap">
			<div class="video-player-wrap" :class="{ show: switchMedia == 'video' }" v-if="goodsSkuDetail.video_url != ''">
				<video-player v-if="goodsSkuDetail.video_url != ''" ref="videoPlayer" :playsinline="true" :options="playerOptions"
				 @play="onPlayerPlay($event)" @pause="onPlayerPause($event)" @ended="onPlayerEnded($event)" @waiting="onPlayerWaiting($event)"
				 @playing="onPlayerPlaying($event)" @loadeddata="onPlayerLoadeddata($event)" @timeupdate="onPlayerTimeupdate($event)"
				 @canplay="onPlayerCanplay($event)" @canplaythrough="onPlayerCanplaythrough($event)" @statechanged="playerStateChanged($event)"
				 @ready="playerReadied"></video-player>

				<div class="media-mode" v-if="goodsSkuDetail.video_url != ''">
					<span :class="{ 'ns-bg-color': switchMedia == 'video' }" @click="switchMedia = 'video'">视频</span>
					<span :class="{ 'ns-bg-color': switchMedia == 'img' }" @click="switchMedia = 'img'">图片</span>
				</div>
			</div>
			<!-- , { size: 'big' } -->
			<div class="magnifier-wrap">
				<img src="../../../assets/images/zp1.jpg"/>
			</div>

			

			<div class="share-collect">
				<div @click="editCollection">
					<i class="iconfont" :class="whetherCollection == 1 ? 'iconlikefill ns-text-color' : 'iconlike'"></i>
					<span data-collects="0" class="focus-text" v-if="goodsSkuDetail.collect_num > 0">关注职位（{{ goodsSkuDetail.collect_num }}）</span>
					<span data-collects="0" class="focus-text" v-else>关注职位</span>
				</div>
				<div @click="service_link">
					<i class="iconfont iconzhanghao"></i>
					<span data-collects="0">联系客服</span>
				</div>

			</div>
		</div>

		<!-- 商品信息 -->
		<div class="basic-info-wrap" v-loading="loading">
			<h1>CNC/数控操作工</h1>
			<p class="desc ns-text-color" v-if="goodsSkuDetail.introduction">{{ goodsSkuDetail.introduction }}</p>

			<div class="discount-banner ns-bg-color" v-if="goodsSkuDetail.promotion_type == 1 && discountTimeMachine.currentTime && addonIsExit.discount">
				<div class="activity-name">
					<i class="discount-icon iconfont iconicon_naozhong"></i>
					<span>限时折扣</span>
				</div>
				<div class="surplus-time">
					<span>{{ discountText }}</span>
					<count-down class="count-down" v-on:start_callback="countDownS_cb()" v-on:end_callback="countDownE_cb()"
					 :currentTime="discountTimeMachine.currentTime" :startTime="discountTimeMachine.startTime" :endTime="discountTimeMachine.endTime"
					 :dayTxt="'天'" :hourTxt="'小时'" :minutesTxt="'分钟'" :secondsTxt="'秒'"></count-down>

					<!-- :tipText="'距离开始文字1'"
					:tipTextEnd="'距离结束文字1'"
                    :endText="'结束自定义文字2'"-->
				</div>
			</div>

			<div class="item-block">
				<div class="promotion-price" >
					<dl class="item-line">
						<!-- <dt class="ns-text-color-gray"></dt> -->
						<dd>
							<em class="yuan ns-text-color">	</em>
							<span class="price ns-text-color">8500-10000元/月</span>
						</dd>
					</dl>
					<dl class="item-line" v-if="goodsSkuDetail.is_virtual == 0">
						<!-- <dt></dt> -->
						<dd>
							<el-tag style="margin: 2px;">1年内经验</el-tag>
							<el-tag style="margin: 2px;" type="success">薪资周结</el-tag>
							<el-tag style="margin: 2px;" type="info">包住</el-tag>
							<el-tag style="margin: 2px;" type="warning">包吃</el-tag>
							<!-- <el-tag style="margin: 2px;" type="danger">标签五</el-tag> -->
						</dd>
					</dl>
				</div>
			</div>
			<dl class="item-line delivery" v-if="goodsSkuDetail.is_virtual == 0">
				
				<dd>
					<div class="region-selected ns-border-color-gray">
						长白数控360一天管住管两餐可周结
					</div>
				</dd>
			</dl>
			<dl class="item-line service">
	
				<dd>
					<span style="font-weight: bold;color: blue;">
						招100人 学历不限 经验不限
					</span>
				</dd>
			</dl>
			<dl class="item-line buy-btn">
				<dt></dt>
				<dd>
					<template  v-if="goodsSkuDetail.goods_state == 1 && goodsSkuDetail.verify_state == 1 && goodsSkuDetail.stock > 0">
						<!-- plain  鼠标划入变换效果 -->
						<el-button type="primary" @click="buyNow">立即申请</el-button>
						<!-- <el-button type="primary" icon="el-icon-shopping-cart-2" v-if="goodsSkuDetail.is_virtual == 0" @click="joinCart" style="background: #FF860F;">加入购物车</el-button> -->
					</template>
					<!-- <template v-else>
						<el-button type="info" plain disabled>库存不足</el-button>
					</template>
					<div href="javascript:;" class="go-phone">
						<span style="color: #666666;margin-right: 10px;">手机购买</span>
						<img src="@/assets/images/goods/qrcode.png" /> 
						<div class="qrcode-wrap"><img :src="qrcode" alt="二维码图片" /></div>
					</div> -->
				</dd>
			</dl>

			
		</div>

		<!-- 店铺信息 -->
		<div class="shop-wrap">
			<div class="head-wrap">
				<div class="img-wrap">
					<img class="img-responsive center-block" :src="shopInfo.avatar ? $img(shopInfo.avatar) : $img(defaultShopImage)"
					 @error="shopInfo.avatar = defaultShopImage" :alt="shopInfo.site_name" />
				</div>
				<h5>
					<span class="site-name">宏源辰企业管理咨询有限公司</span>
					<el-tag class="tag" size="small" v-if="shopInfo.is_own == 1">自营</el-tag>
				</h5>
			</div>
			<div class="info-wrap">
				<dl>
					<dt class="site-score">企业评分</dt>
					<dd>
						<el-rate v-model="score" disabled></el-rate>
					</dd>
					<dt>职位描述：</dt>
					<dd>
						<span>{{ shopInfo.shop_desccredit }}</span>
						分
					</dd>
					<dt>企业服务：</dt>
					<dd>
						<span>{{ shopInfo.shop_servicecredit }}</span>
						分
					</dd>
					<dt>跟进速度：</dt>
					<dd>
						<span>{{ shopInfo.shop_deliverycredit }}</span>
						分
					</dd>
				</dl>
			</div>
			<div class="info-wrap" v-if="shopInfo.telephone">
				<dl>
					<dt>联系电话：</dt>
					<dd>{{ shopInfo.telephone }}</dd>
				</dl>
			</div>
			<div class="operation">
				<!-- <el-button class="btn btn-default" size="medium" @click="$router.pushToTab('shop-' + shopInfo.site_id)">进店逛逛</el-button> -->
				<el-button size="medium" @click="follow" v-if="hasFollow">取消关注</el-button>
				<el-button size="medium" @click="follow" v-else>关注企业</el-button>
			</div>
		</div>

		

		<div class="detail-wrap">
			<div class="goods-recommended">
				<!-- <goods-recommend /> -->
			</div>

			<el-tabs class="goods-tab" v-model="tabName" type="card" @tab-click="tabChange">
				<el-tab-pane label="详情" name="detail">
					<div >
						<div class="item_con">
										<!--职位描述-->
						<div class="subitem_con pos_description">
									<h2 class="title">职位描述</h2>
								<div class="posDes" style="height: 360px;">
									<div class="des">
										【岗位职责】<br>* 坐班操作工，主要从事基础性生产辅助工作<br>【职位要求】<br>* 年龄18-40岁，女性<br>* 无经验可，公司提供简单培训<br>* 正式工，坐班制，<br>* 学历不限，经验不限<br>【工作时间】<br>* 08:00-17:00，周末休息<br>【薪资福利】<br>* 综合薪资2000-3000元/月<br>* 工资按时发放，稳定有保障
									</div>
									<div class="Job requirements">
													</div>
								</div>
								<div class="lookMore" tongji_tag="pc_detail_job_full_zwmszk_a" style="display: none;">
									<span>查看更多<i class="arrow"></i></span>
								</div>
							</div>				<!--公司简介-->
						<div class="subitem_con comp_intro">
							<h2 class="title">公司介绍</h2>
															<div class="txt">
										<div class="comIntro" style="height: 240px;">
											<div class="intro">
										   		<div class="shiji">
							     					<p>青岛宏源辰企业管理咨询有限公司,成立日期:2022年04月27日,创建于青岛市,经营范围:一般项目：企业管理咨询；会议及展览服务；普通货物仓储服务（不含危险化学品等需许可审批的项目）；装卸搬运；园林绿化工程施工；专业保洁、清洗、消毒服务；家政服务；物业管理；酒店管理；企业形象策划；五金产品批发；五金产品零售；机械设备销售；电子、机械设备维护（不含特种设备）；办公用品销售；模具制造；模具销售；电子元器件与机电组件设备制造；电子元器件制造；电子元器件批发；人力资源服务（不含职业中介活动、劳务派遣服务）。（除依法须经批准的项目外，凭营业执照依法自主开展经营活动）许可项目：职业中介活动；建筑劳务分包；劳务派遣服务。（依法须经批准的项目，经相关部门批准后方可开展经营活动，具体经营项目以相关部门批准文件或许可证件为准）,企业注册地址:中国（山东）自由贸易试验区青岛片区江山中路156号办公913户;诚挚邀请您的加入！</p>
												</div>
											</div>
										</div>
									</div>
									<div class="lookMore" tongji_tag="pc_detail_job_full_gsxxzk_a" style="display: none;">
										<span>查看更多<i class="arrow"></i></span>
									</div> 
									</div>
									</div>
					</div>
				</el-tab-pane>
				
				
				<!-- <el-tab-pane label="售后保障" name="after_sale" class="after-sale" v-if="service_is_display.is_display==1">
					<div v-html="service"></div>
				</el-tab-pane> -->
			</el-tabs>
		</div>
		<div>1</div>
		<!--联系客服弹窗-->
		<!-- <servicerMessage ref="servicerMessage" class="kefu" :shop="{shop_id:shopInfo.site_id,logo:shopInfo.logo,shop_name:shopInfo.site_name}"></servicerMessage> -->
	</div>
</template>

<script>
	import PicZoom from 'vue-piczoom';
	import detail from './detail';
	import GoodsRecommend from '@/components/GoodsRecommend';
	import servicerMessage from "@/components/message/servicerMessage";
	export default {
		name: 'detail',
		components: {
			PicZoom,
			GoodsRecommend,
			servicerMessage
		},
		mixins: [detail]
	};
</script>
<style lang="scss">
	@import './detail.scss';
</style>
